// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_PorPlanoContasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /despesas/por_plano_contas
 *
 * Returns a list of despesas (expenses) filtered by plano_conta_id.
 *
 * Each item in the array contains:
 * - despesa_id: Expense ID
 * - despesa_titulo: Expense title
 * - despesa_descricao: Expense description
 * - despesa_valor: Expense amount
 * - despesa_data_vencimento: Due date (DATE-only, YYYY-MM-DD)
 * - despesa_status: Expense status
 *
 * @see Despesas_Model::getDespesasByPlanoContas() for the source query
 */
import type { Despesas_PorPlanoContasRow } from './Despesas_PorPlanoContasRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Despesas_PorPlanoContasResponseDados = Despesas_PorPlanoContasRow[];

export type Despesas_PorPlanoContasResponse = ApiResponse<Despesas_PorPlanoContasResponseDados>;

registerResponseContract('Despesas_PorPlanoContasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      despesa_id:              { type: 'number',  required: true },
      despesa_titulo:          { type: 'string',  required: true },
      despesa_descricao:       { type: 'string',  required: false },
      despesa_valor:           { type: 'number',  required: true },
      despesa_data_vencimento: { type: 'string',  required: false },
      despesa_status:          { type: 'number',  required: true },
    },
  },
})
